import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "linkedin-profile-tab" }
const _hoisted_2 = {
  key: 0,
  class: "profile-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "profile-error"
}
const _hoisted_4 = { class: "profile-error__message" }
const _hoisted_5 = {
  key: 2,
  class: "profile-empty"
}
const _hoisted_6 = {
  key: 3,
  class: "profile-card"
}
const _hoisted_7 = { class: "profile-header" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "profile-avatar__overlay" }
const _hoisted_11 = {
  key: 1,
  class: "profile-avatar"
}
const _hoisted_12 = { class: "profile-avatar__placeholder" }
const _hoisted_13 = { class: "profile-meta" }
const _hoisted_14 = { class: "profile-role" }
const _hoisted_15 = { class: "profile-location" }
const _hoisted_16 = {
  key: 0,
  class: "profile-throttled"
}
const _hoisted_17 = {
  key: 1,
  class: "profile-section"
}
const _hoisted_18 = {
  key: 2,
  class: "profile-section"
}
const _hoisted_19 = { class: "profile-summary" }
const _hoisted_20 = {
  key: 3,
  class: "profile-section"
}
const _hoisted_21 = { class: "experience-list" }
const _hoisted_22 = { class: "experience-header" }
const _hoisted_23 = { class: "experience-title" }
const _hoisted_24 = { class: "experience-duration" }
const _hoisted_25 = { class: "experience-company" }
const _hoisted_26 = {
  key: 0,
  class: "experience-location"
}
const _hoisted_27 = {
  key: 1,
  class: "experience-description"
}
const _hoisted_28 = {
  key: 4,
  class: "profile-section"
}
const _hoisted_29 = { class: "education-list" }
const _hoisted_30 = { class: "education-header" }
const _hoisted_31 = { class: "education-school" }
const _hoisted_32 = { class: "education-duration" }
const _hoisted_33 = {
  key: 0,
  class: "education-degree"
}
const _hoisted_34 = {
  key: 1,
  class: "education-field"
}
const _hoisted_35 = {
  key: 5,
  class: "profile-section"
}
const _hoisted_36 = { class: "skills-container" }
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "skill-endorsements"
}
const _hoisted_39 = {
  key: 6,
  class: "profile-section"
}
const _hoisted_40 = { class: "languages-list" }
const _hoisted_41 = { class: "language-name" }
const _hoisted_42 = {
  key: 0,
  class: "language-proficiency"
}
const _hoisted_43 = {
  key: 7,
  class: "profile-section"
}
const _hoisted_44 = { class: "certifications-list" }
const _hoisted_45 = { class: "certification-name" }
const _hoisted_46 = {
  key: 0,
  class: "certification-org"
}
const _hoisted_47 = {
  key: 1,
  class: "certification-dates"
}
const _hoisted_48 = {
  key: 8,
  class: "profile-section"
}
const _hoisted_49 = { class: "projects-list" }
const _hoisted_50 = { class: "project-header" }
const _hoisted_51 = { class: "project-name" }
const _hoisted_52 = {
  key: 0,
  class: "project-duration"
}
const _hoisted_53 = {
  key: 0,
  class: "project-description"
}
const _hoisted_54 = ["href"]
const _hoisted_55 = {
  key: 9,
  class: "profile-section"
}
const _hoisted_56 = { class: "volunteering-list" }
const _hoisted_57 = { class: "volunteering-header" }
const _hoisted_58 = { class: "volunteering-role" }
const _hoisted_59 = { class: "volunteering-duration" }
const _hoisted_60 = { class: "volunteering-org" }
const _hoisted_61 = {
  key: 0,
  class: "volunteering-cause"
}
const _hoisted_62 = {
  key: 1,
  class: "volunteering-description"
}
const _hoisted_63 = {
  key: 10,
  class: "profile-section"
}
const _hoisted_64 = { class: "recommendations-list" }
const _hoisted_65 = { class: "recommendation-content" }
const _hoisted_66 = { class: "recommendation-quote-icon" }
const _hoisted_67 = {
  key: 0,
  class: "recommendation-text"
}
const _hoisted_68 = {
  key: 1,
  class: "recommendation-caption"
}
const _hoisted_69 = {
  key: 0,
  class: "recommendation-actor"
}
const _hoisted_70 = ["href"]
const _hoisted_71 = {
  key: 0,
  class: "recommendation-actor-avatar"
}
const _hoisted_72 = ["src", "alt", "onError"]
const _hoisted_73 = {
  key: 1,
  class: "recommendation-actor-avatar recommendation-actor-avatar--placeholder"
}
const _hoisted_74 = { class: "recommendation-actor-info" }
const _hoisted_75 = { class: "recommendation-actor-name" }
const _hoisted_76 = {
  key: 0,
  class: "recommendation-actor-headline"
}
const _hoisted_77 = {
  key: 1,
  class: "recommendation-actor recommendation-actor--no-link"
}
const _hoisted_78 = {
  key: 0,
  class: "recommendation-actor-avatar"
}
const _hoisted_79 = ["src", "alt", "onError"]
const _hoisted_80 = {
  key: 1,
  class: "recommendation-actor-avatar recommendation-actor-avatar--placeholder"
}
const _hoisted_81 = { class: "recommendation-actor-info" }
const _hoisted_82 = { class: "recommendation-actor-name" }
const _hoisted_83 = {
  key: 0,
  class: "recommendation-actor-headline"
}

import { computed, ref } from "vue";
import { Icon } from "@iconify/vue";
import Button from "@/components/ui/Button.vue";
import LoadingBars from "@/components/ui/LoadingBars.vue";

interface MonthYear {
  month?: number;
  year?: number;
}

interface WorkExperience {
  position?: string;
  title?: string;
  company?: string;
  company_name?: string;
  location?: string;
  description?: string;
  start?: string;
  end?: string;
  start_date?: MonthYear;
  end_date?: MonthYear | null;
  current?: boolean;
  is_current?: boolean;
}

interface EducationRaw {
  degree?: string;
  field_of_study?: string;
  school?: string;
  school_name?: string;
  start?: string;
  end?: string;
  start_date?: MonthYear;
  end_date?: MonthYear | null;
}

interface SkillRaw {
  name: string;
  endorsement_count?: number;
}

interface ProfileData {
  contactName?: string;
  contactRole?: string;
  location?: string;
  summary?: string;
  profilePictureUrl?: string;
  workExperience?: WorkExperience[];
  education?: EducationRaw[];
  skills?: (string | SkillRaw)[];
  languages?: Array<{
    name?: string;
    proficiency?: string;
  }>;
  certifications?: Array<{
    name?: string;
    issuing_organization?: string;
    issuingOrganization?: string;
    issue_date?: string;
    issueDate?: string;
    expiration_date?: string | null;
    expirationDate?: string | null;
    credential_id?: string;
    credential_url?: string;
    url?: string;
  }>;
  projects?: Array<{
    name?: string;
    description?: string;
    url?: string;
    credential_url?: string;
    start?: string;
    end?: string | null;
    duration?: string;
  }>;
  volunteeringExperience?: Array<{
    organization?: string;
    role?: string;
    cause?: string;
    description?: string;
    start?: string;
    end?: string | null;
    duration?: string;
  }>;
  recommendations?: {
    received?: Array<{
      text?: string;
      caption?: string;
      actor?: {
        first_name?: string;
        last_name?: string;
        provider_id?: string;
        headline?: string;
        public_identifier?: string;
        public_profile_url?: string;
        profile_picture_url?: string;
      };
    }>;
    received_total_count?: number;
  };
}

interface ExperienceItem {
  title: string;
  company: string;
  duration: string;
  location?: string;
  description?: string;
}

interface EducationItem {
  degree: string;
  institution: string;
  duration: string;
  fieldOfStudy?: string;
}

interface Props {
  profile?: ProfileData | null;
  loading?: boolean;
  error?: string | null;
  throttledSections?: string[];
  mode?: "me" | "contact";
}

interface SkillDisplay {
  name: string;
  endorsements?: number;
}

const maxDisplayedSkills = 20;


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedInProfileTab',
  props: {
    profile: { default: null },
    loading: { type: Boolean, default: false },
    error: { default: null },
    throttledSections: { default: () => [] },
    mode: { default: "contact" }
  },
  emits: ["retry"],
  setup(__props: any) {

const props = __props;



const avatarFailed = ref(false);
const onAvatarError = () => {
  avatarFailed.value = true;
};

const recommendationAvatarFailed = ref<Record<number, boolean>>({});
const onRecommendationAvatarError = (index: number) => {
  recommendationAvatarFailed.value[index] = true;
};

function parseDate(input?: string): Date | null {
  if (!input) return null;

  // Handle "M/D/YYYY" format (e.g., "7/1/2020")
  const dateMatch = input.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dateMatch) {
    const [, month, day, year] = dateMatch;
    const d = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return isNaN(d.getTime()) ? null : d;
  }

  // Try standard date parsing
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

function monthYearToDateString(input?: MonthYear | null): string | undefined {
  if (!input?.year) return undefined;
  const month = input.month && input.month >= 1 && input.month <= 12 ? input.month : 1;
  const d = new Date(Date.UTC(input.year, month - 1, 1));
  return d.toISOString();
}

function diffMonths(start: Date, end: Date): number {
  return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
}

function formatDurationShort(start?: string, end?: string, isCurrent?: boolean): string {
  const s = parseDate(start);
  const e = isCurrent ? new Date() : parseDate(end);
  if (!s || !e) return "";
  const months = Math.max(0, diffMonths(s, e));
  const years = Math.floor(months / 12);
  if (years >= 1) return `${years} yr${years > 1 ? "s" : ""}`;
  if (months >= 1) return `${months} mo${months > 1 ? "s" : ""}`;
  return "";
}

function formatYearRange(start?: string, end?: string): string {
  const s = parseDate(start);
  const e = parseDate(end);
  const sy = s ? s.getFullYear() : null;
  const ey = e ? e.getFullYear() : null;
  if (sy && ey) return `${sy} - ${ey}`;
  if (sy) return `${sy}`;
  if (ey) return `${ey}`;
  return "";
}

function summaryToBullets(summary?: string): string[] {
  if (!summary) return [];
  const trimmed = summary.trim();
  if (!trimmed) return [];
  if (trimmed.includes("\n")) {
    return trimmed
      .split("\n")
      .map((s) => s.trim())
      .filter(Boolean)
      .slice(0, 8);
  }
  const sentences = trimmed
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean);
  if (sentences.length <= 1) return [trimmed];
  return sentences.slice(0, 8);
}

const overview = computed(() => summaryToBullets(props.profile?.summary));

const showAllSkills = ref(false);
const skills = computed<SkillDisplay[]>(() => {
  const list = props.profile?.skills || [];
  return list
    .map((s) => {
      if (typeof s === "string") {
        return { name: s.trim() };
      }
      return {
        name: (s?.name || "").trim(),
        endorsements: s?.endorsement_count,
      };
    })
    .filter((s) => s.name);
});

const displayedSkills = computed(() => {
  if (showAllSkills.value) return skills.value;
  return skills.value.slice(0, maxDisplayedSkills);
});

const languages = computed(() => {
  return props.profile?.languages || [];
});

const certifications = computed(() => {
  return props.profile?.certifications || [];
});

const projects = computed(() => {
  const list = (props.profile?.projects || []) as Array<{
    name?: string;
    description?: string;
    url?: string;
    credential_url?: string;
    start?: string;
    end?: string | null;
    duration?: string;
  }>;
  return list.map((p) => ({
    name: p.name || "",
    description: p.description || "",
    url: p.url || p.credential_url || "",
    duration: formatYearRange(p.start, p.end ?? undefined),
  }));
});

const volunteering = computed(() => {
  const list = props.profile?.volunteeringExperience || [];
  return list.map((v) => ({
    role: v.role || "",
    organization: v.organization || "",
    cause: v.cause || "",
    description: v.description || "",
    duration: formatYearRange(v.start, v.end ?? undefined),
  }));
});

const recommendations = computed(() => {
  const received = props.profile?.recommendations?.received || [];
  return received.map((rec) => ({
    text: rec.text || "",
    caption: rec.caption || "",
    actor: {
      firstName: rec.actor?.first_name || "",
      lastName: rec.actor?.last_name || "",
      fullName: [rec.actor?.first_name, rec.actor?.last_name].filter(Boolean).join(" ") || "",
      headline: rec.actor?.headline || "",
      profileUrl: rec.actor?.public_profile_url || "",
      pictureUrl: rec.actor?.profile_picture_url || "",
    },
  }));
});

const experience = computed<ExperienceItem[]>(() => {
  const list = (props.profile?.workExperience || []) as WorkExperience[];
  return list
    .map((e: WorkExperience) => {
      const title = e.title || e.position || "";
      const company = e.company || e.company_name || "";
      const start = e.start || monthYearToDateString(e.start_date);
      const end =
        e.end || (e.end_date === null ? undefined : monthYearToDateString(e.end_date)) || undefined;
      const duration = formatDurationShort(start, end, !!(e.current || e.is_current));
      const location = e.location || "";
      const description = e.description || "";
      return { title, company, duration, location, description };
    })
    .filter((x) => x.title);
});

const education = computed<EducationItem[]>(() => {
  const list = props.profile?.education || [];
  return list
    .map((e) => {
      const degree = [e.degree, e.field_of_study].filter(Boolean).join(", ") || "";
      const institution = e.school || e.school_name || "";
      const start = e.start || monthYearToDateString(e.start_date);
      const end =
        e.end || (e.end_date === null ? undefined : monthYearToDateString(e.end_date)) || undefined;
      const duration = formatYearRange(start, end);
      const fieldOfStudy = e.field_of_study || "";
      return { degree, institution, duration, fieldOfStudy };
    })
    .filter((x) => x.degree || x.institution);
});

const formatCertificationDates = (issueDate?: string, expirationDate?: string | null): string => {
  const issue = issueDate ? parseDate(issueDate) : null;
  const expire = expirationDate ? parseDate(expirationDate) : null;

  if (issue && expire) {
    return `${issue.getFullYear()} - ${expire.getFullYear()}`;
  }
  if (issue) {
    return `Issued ${issue.getFullYear()}`;
  }
  if (expire) {
    return `Expires ${expire.getFullYear()}`;
  }
  return "";
};

const throttledSections = computed(() => props.throttledSections || []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingBars, { size: "sm" })
        ]))
      : (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(Icon), {
              icon: "mdi:alert-circle-outline",
              class: "profile-error__icon"
            }),
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.error), 1),
            _createVNode(Button, {
              variant: "primary",
              size: "sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Try Again", -1)
              ]))]),
              _: 1
            })
          ]))
        : (!__props.profile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(Icon), {
                icon: "mdi:account-circle-outline",
                class: "profile-empty__icon"
              }),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "No profile data available", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (__props.profile.profilePictureUrl && !avatarFailed.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: __props.profile.profilePictureUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "profile-avatar profile-avatar--clickable"
                    }, [
                      _createElementVNode("img", {
                        src: __props.profile.profilePictureUrl,
                        alt: __props.profile.contactName || 'Profile photo',
                        onError: onAvatarError
                      }, null, 40, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:open-in-new",
                          class: "profile-avatar__icon"
                        })
                      ])
                    ], 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:account",
                          width: "28",
                          height: "28"
                        })
                      ])
                    ])),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", null, _toDisplayString(__props.profile.contactName || ""), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(__props.profile.contactRole || ""), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(__props.profile.location || ""), 1)
                ])
              ]),
              (throttledSections.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Some profile sections may be unavailable right now (rate limited by LinkedIn). "))
                : _createCommentVNode("", true),
              (overview.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[4] || (_cache[4] = _createElementVNode("h6", null, "OVERVIEW", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overview.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.profile.summary)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[5] || (_cache[5] = _createElementVNode("h6", null, "ABOUT", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(__props.profile.summary), 1)
                  ]))
                : _createCommentVNode("", true),
              (experience.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[6] || (_cache[6] = _createElementVNode("h6", null, "EXPERIENCE", -1)),
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experience.value, (exp, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "experience-item"
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(exp.title), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(exp.duration), 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(exp.company), 1),
                          (exp.location)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(exp.location), 1))
                            : _createCommentVNode("", true),
                          (exp.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(exp.description), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (education.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _cache[7] || (_cache[7] = _createElementVNode("h6", null, "EDUCATION", -1)),
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(education.value, (edu, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "education-item"
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(edu.institution), 1),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(edu.duration), 1)
                          ]),
                          (edu.degree)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(edu.degree), 1))
                            : _createCommentVNode("", true),
                          (edu.fieldOfStudy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(edu.fieldOfStudy), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (skills.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _cache[8] || (_cache[8] = _createElementVNode("h6", null, "SKILLS", -1)),
                    _createElementVNode("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedSkills.value, (skill, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "skill-tag",
                          title: skill.endorsements ? `${skill.endorsements} endorsements` : ''
                        }, [
                          _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                          (skill.endorsements)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, " (" + _toDisplayString(skill.endorsements) + ") ", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_37))
                      }), 128))
                    ]),
                    (skills.value.length > maxDisplayedSkills)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "show-more-btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showAllSkills.value = !showAllSkills.value))
                        }, _toDisplayString(showAllSkills.value ? "Show Less" : `Show ${skills.value.length - maxDisplayedSkills} More`), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (languages.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _cache[9] || (_cache[9] = _createElementVNode("h6", null, "LANGUAGES", -1)),
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (lang, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "language-item"
                        }, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(lang.name), 1),
                          (lang.proficiency)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(lang.proficiency), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (certifications.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _cache[10] || (_cache[10] = _createElementVNode("h6", null, "CERTIFICATIONS", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certifications.value, (cert, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "certification-item"
                        }, [
                          _createElementVNode("div", _hoisted_45, _toDisplayString(cert.name), 1),
                          (cert.issuingOrganization)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(cert.issuingOrganization), 1))
                            : _createCommentVNode("", true),
                          (cert.issueDate || cert.expirationDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(formatCertificationDates(cert.issueDate, cert.expirationDate)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (projects.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _cache[12] || (_cache[12] = _createElementVNode("h6", null, "PROJECTS", -1)),
                    _createElementVNode("div", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "project-item"
                        }, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, _toDisplayString(project.name), 1),
                            (project.duration)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(project.duration), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (project.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(project.description), 1))
                            : _createCommentVNode("", true),
                          (project.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: project.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "project-link"
                              }, [
                                _createVNode(_unref(Icon), { icon: "mdi:open-in-new" }),
                                _cache[11] || (_cache[11] = _createTextVNode(" View Project ", -1))
                              ], 8, _hoisted_54))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (volunteering.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _cache[13] || (_cache[13] = _createElementVNode("h6", null, "VOLUNTEERING", -1)),
                    _createElementVNode("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volunteering.value, (vol, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "volunteering-item"
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, _toDisplayString(vol.role), 1),
                            _createElementVNode("div", _hoisted_59, _toDisplayString(vol.duration), 1)
                          ]),
                          _createElementVNode("div", _hoisted_60, _toDisplayString(vol.organization), 1),
                          (vol.cause)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(vol.cause), 1))
                            : _createCommentVNode("", true),
                          (vol.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(vol.description), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (recommendations.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _cache[14] || (_cache[14] = _createElementVNode("h6", null, "RECOMMENDATIONS", -1)),
                    _createElementVNode("div", _hoisted_64, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendations.value, (rec, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "recommendation-item"
                        }, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_unref(Icon), { icon: "mdi:format-quote-open" })
                            ]),
                            (rec.text)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(rec.text), 1))
                              : _createCommentVNode("", true),
                            (rec.caption)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(rec.caption), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (rec.actor.fullName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (rec.actor.profileUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: rec.actor.profileUrl,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      class: "recommendation-actor-link"
                                    }, [
                                      (rec.actor.pictureUrl && !recommendationAvatarFailed.value[index])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            _createElementVNode("img", {
                                              src: rec.actor.pictureUrl,
                                              alt: rec.actor.fullName,
                                              onError: ($event: any) => (onRecommendationAvatarError(index))
                                            }, null, 40, _hoisted_72)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                            _createVNode(_unref(Icon), {
                                              icon: "mdi:account",
                                              width: "20",
                                              height: "20"
                                            })
                                          ])),
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, _toDisplayString(rec.actor.fullName), 1),
                                        (rec.actor.headline)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(rec.actor.headline), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_unref(Icon), {
                                        icon: "mdi:open-in-new",
                                        class: "recommendation-actor-external-icon"
                                      })
                                    ], 8, _hoisted_70))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                      (rec.actor.pictureUrl && !recommendationAvatarFailed.value[index])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                            _createElementVNode("img", {
                                              src: rec.actor.pictureUrl,
                                              alt: rec.actor.fullName,
                                              onError: ($event: any) => (onRecommendationAvatarError(index))
                                            }, null, 40, _hoisted_79)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                            _createVNode(_unref(Icon), {
                                              icon: "mdi:account",
                                              width: "20",
                                              height: "20"
                                            })
                                          ])),
                                      _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, _toDisplayString(rec.actor.fullName), 1),
                                        (rec.actor.headline)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(rec.actor.headline), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
  ]))
}
}

})